module.exports = __webpack_public_path__ + "media/images/member_notice-a95f3302d672530b6d8367b32608b777.svg";